import { render } from "./AIClientContent.vue?vue&type=template&id=6f041bdd&scoped=true"
import script from "./AIClientContent.vue?vue&type=script&lang=js"
export * from "./AIClientContent.vue?vue&type=script&lang=js"

import "./AIClientContent.vue?vue&type=style&index=0&id=6f041bdd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f041bdd"]])

export default __exports__